import React from 'react'

interface StatsCardProps {
  label: string
  icon?: React.ReactNode
  value?: React.ReactNode
  sub?: string
  footer?: React.ReactNode
  children?: React.ReactNode
  className?: string
}

const StatsCard: React.FC<StatsCardProps> = ({ label, icon, value, sub, footer, children, className }) => {
  return (
    <div className={`flex flex-col rounded-lg border border-divider bg-surface-faint p-4 ${className ?? ''}`}>
      <div className="flex items-center gap-2 text-muted">
        {icon && <span className="flex items-center justify-center w-[40px] h-[40px] text-blue">{icon}</span>}
        <span className="text-sm font-medium">{label}</span>
      </div>
      {value !== undefined && <span className="text-2xl font-bold mt-1">{value}</span>}
      {sub && <div className="text-xs text-muted mt-1">{sub}</div>}
      {children}
      {footer && <div className="mt-auto pt-[12px]">{footer}</div>}
    </div>
  )
}

export default StatsCard
